module.exports = __webpack_public_path__ + "static/media/whiteBack.1b817370.svg";